module.exports = __webpack_public_path__ + "static/media/help.0c42cd9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/help.jpg
// module id = 1142
// module chunks = 0